export default __webpack_public_path__ + "static/media/weed-control.10ddc654.jpg";